import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'app-student-free-response-scoring',
  templateUrl: './free-response-points.component.html',
  styleUrls: ['./free-response-points.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StudentFreeResponseScoringComponent {
  @Input() public score: number = 0;
}
